import ModalContainer from 'components/modal/modal-container'

import ModalActions from 'components/modal/modal-actions'
import { Button } from '@mui/material'

import { closeModal } from 'actions/app'

import { deleteClients } from 'api/client'
import { useTranslation } from 'react-i18next'

import type { AppState } from 'state/index'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'

export default function OCFFDeleteClient(props) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { selectedClients, onSuccess } = props

  const defaultClient = useSelector(
    (state) => (state as AppState).account.singleton.prefs?.cff?.client,
  )

  const [defaultDeletionMsg, showDefaultDeletionMsg] = useState(false)

  useEffect(() => {
    if (
      defaultClient &&
      selectedClients.some(
        (client) => parseInt(defaultClient) === parseInt(client.id),
      )
    ) {
      showDefaultDeletionMsg(true)
    }
  }, [selectedClients, defaultClient])

  const closePopup = () => dispatch(closeModal())

  const deleteItem = () => {
    //@ts-expect-error
    dispatch(deleteClients(selectedClients.map((client) => client.id))).then(
      () => {
        if (onSuccess) onSuccess()
      },
    )
  }

  return (
    <ModalContainer>
      {defaultDeletionMsg ? (
        <>
          <div>
            {t('cannot_delete_default', {
              entity: t('client'),
            })}
          </div>
          <ModalActions>
            <Button variant="contained" color="primary" onClick={closePopup}>
              {t('ok')}
            </Button>
          </ModalActions>
        </>
      ) : selectedClients.some((client) => client.farmsQuantity > 0) ? (
        <>
          <div>
            {t('delete_child_entity_first', {
              parentEntityName: name,
              childEntity: t('farms'),
              parentEntity: t('client'),
            })}
          </div>
          <ModalActions>
            <Button variant="contained" color="primary" onClick={closePopup}>
              {t('ok')}
            </Button>
          </ModalActions>
        </>
      ) : (
        <>
          <div>
            {selectedClients.length > 1
              ? t('delete_multiple_item_warning', {
                  count: selectedClients.length,
                  item: t('clients'),
                })
              : t('delete_item_warning', { name: selectedClients[0].name })}
            <br />
            {t('delete_cannot_be_undone')}
          </div>
          <ModalActions>
            <Button variant="contained" color="secondary" onClick={closePopup}>
              {t('cancel')}
            </Button>
            <Button variant="contained" color="primary" onClick={deleteItem}>
              {t('delete')}
            </Button>
          </ModalActions>
        </>
      )}
    </ModalContainer>
  )
}
